// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.layertree-option-layerfilters {
    height: auto !important;
}
.layer-filters > div {
    margin-bottom: 1px;
}
.layer-filter-label {
    font-weight: bold;
    background-color: #afb3b2;
    padding: 10px 10px 10px 15px !important;
    display: flex;
    color: inherit;
    text-decoration: none;
    justify-content: space-between;
    align-items: center;
}
.layer-filter-label:hover {
    text-decoration: none;
}
.layer-filter-label .text {
    flex-grow: 1;
}
.layer-filter-label .icon-confirm {
    margin-right: 5px;
}
.layer-filter-checkbox label {
    display: flex;
    align-items: flex-start;
}
.layer-filter-input {
    padding: 10px 10px 10px 15px;
}
.layer-filter-checkbox input {
    margin-right: 4px;
    margin-top: 2px;
}
.layer-filters {
    width: 100%;
}
.layer-filters button {
    margin-right: 5px;
}
.multi-range-slider {
    box-shadow: none !important;
    border: 0 !important;
}
.multi-range-slider .bar-left {
    box-shadow: none !important;
}
.multi-range-slider .bar-right {
    box-shadow: none !important;
}
.multi-range-slider .bar-inner {
    box-shadow: none !important;
}
.multi-range-slider .thumb .caption * {
    box-shadow: none !important;
    background-color: #afb3b2 !important;
}
.multi-range-slider .thumb::before {
    box-shadow: none !important;
    margin-top: -6px !important;
}
.layer-filter-buttons {
    padding: 10px 10px 10px 15px;
}
`, "",{"version":3,"sources":["webpack://./js/style/LayerFilter.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,uCAAuC;IACvC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,oCAAoC;AACxC;AACA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC","sourcesContent":["\n.layertree-option-layerfilters {\n    height: auto !important;\n}\n.layer-filters > div {\n    margin-bottom: 1px;\n}\n.layer-filter-label {\n    font-weight: bold;\n    background-color: #afb3b2;\n    padding: 10px 10px 10px 15px !important;\n    display: flex;\n    color: inherit;\n    text-decoration: none;\n    justify-content: space-between;\n    align-items: center;\n}\n.layer-filter-label:hover {\n    text-decoration: none;\n}\n.layer-filter-label .text {\n    flex-grow: 1;\n}\n.layer-filter-label .icon-confirm {\n    margin-right: 5px;\n}\n.layer-filter-checkbox label {\n    display: flex;\n    align-items: flex-start;\n}\n.layer-filter-input {\n    padding: 10px 10px 10px 15px;\n}\n.layer-filter-checkbox input {\n    margin-right: 4px;\n    margin-top: 2px;\n}\n.layer-filters {\n    width: 100%;\n}\n.layer-filters button {\n    margin-right: 5px;\n}\n.multi-range-slider {\n    box-shadow: none !important;\n    border: 0 !important;\n}\n.multi-range-slider .bar-left {\n    box-shadow: none !important;\n}\n.multi-range-slider .bar-right {\n    box-shadow: none !important;\n}\n.multi-range-slider .bar-inner {\n    box-shadow: none !important;\n}\n.multi-range-slider .thumb .caption * {\n    box-shadow: none !important;\n    background-color: #afb3b2 !important;\n}\n.multi-range-slider .thumb::before {\n    box-shadow: none !important;\n    margin-top: -6px !important;\n}\n.layer-filter-buttons {\n    padding: 10px 10px 10px 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
